/*
 * Author: Chathuraka Mallawa Arachchi(nperera@mitrai.com)
 * Created on: 10-10-19
 * Description: Login screen to provide authentication for user
 * Module: Hedgehog Staff-Portal
 * Copyright (c) 2019 Leap In! All rights reserved.
 */
import React, {Component} from 'react';
import './style.css';
import {Auth} from 'aws-amplify';
import {BrandActivityIndicator} from '../../../Components/Molecules/BrandActivityIndicator';

// Types for props related to route and extended props

class GLogin extends Component {
  state = {
    loading: true,
  };

  componentDidMount() {
    this.signIn();
  }

  async signIn() {
    Auth.federatedSignIn();
  }

  render() {
    return (
      <BrandActivityIndicator enableWeb={true} loading={this.state.loading} />
    );
  }
}

export default GLogin;
